import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AudioPlayerProvider } from './context/AudioPlayerContext';
import reportWebVitals from './reportWebVitals';

// Additional error handling (backup - main handler is in firestore-error-handler.js)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AudioPlayerProvider>
      <App />
    </AudioPlayerProvider>
  </React.StrictMode>
);

// Register service worker for PWA
// A service worker is required for the browser's PWA install prompt.
const ENABLE_SERVICE_WORKER = true;

if ('serviceWorker' in navigator && ENABLE_SERVICE_WORKER) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js', {
      updateViaCache: 'none'
    }).then((registration) => {
      console.log('Service Worker registered successfully:', registration.scope);
      
      // Force immediate update
      registration.update();
      
      // Listen for updates
      registration.addEventListener('updatefound', () => {
        console.log('New service worker found, updating...');
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'activated') {
              console.log('New service worker activated!');
              // Optionally reload page to use new service worker
              // window.location.reload();
            }
          });
        }
      });
    }).catch((error) => {
      console.log('Service Worker registration failed:', error);
    });
  });
  
  // Also provide a way to unregister service worker if needed (for debugging)
  window.unregisterServiceWorker = () => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        return Promise.all(
          registrations.map((registration) => {
            return registration.unregister().then((success) => {
              if (success) {
                console.log('Service Worker unregistered successfully:', registration.scope);
              }
            });
          })
        );
      }).then(() => {
        console.log('All service workers unregistered. Please refresh the page.');
      });
    }
  };
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
